import { BASE_URL, PUBLIC, TOP_COMPANIES } from "../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${TOP_COMPANIES}`; 

export const fetchTopCompanies = async () => {
  const url = `${API_BASE_URL}`; 
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    // console.log("data in api", data)
    return data;
  } catch (error) {
    console.log("error", error);
  }
};